const TeamSection = () => {
  return (
    <div className="bg-gradient-to-br from-gray-100 via-gray-200 to-white text-gray-700 p-8 md:p-8 lg:p-16 shadow-lg">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        {/* Left Image */}
        <div className="flex justify-center">
          <img
            src="/images/team-image.jpg" // Replace with the actual path to your image
            alt="Our Team"
            className="w-full max-w-lg rounded-lg shadow-lg"
          />
        </div>

        {/* Right Content */}
        <div>
          <h2 className="text-3xl font-bold mb-4">Our Team</h2>
          <p className="mb-6">
            Our success is driven by our talented and dedicated team of professionals. From software engineers and IT consultants to hardware specialists and cybersecurity experts, our team brings extensive experience and expertise to every project.
          </p>
          <p>
            We prioritize collaboration, innovation, and continuous learning to ensure we remain at the forefront of technological advancements.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamSection;